import { render, staticRenderFns } from "./g-bujian-table.vue?vue&type=template&id=c679362a&scoped=true&"
import script from "./g-bujian-table.vue?vue&type=script&setup=true&lang=ts&"
export * from "./g-bujian-table.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./g-bujian-table.vue?vue&type=style&index=0&id=c679362a&prod&lang=less&"
import style1 from "./g-bujian-table.vue?vue&type=style&index=1&id=c679362a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c679362a",
  null
  
)

export default component.exports